import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const AYEN_SERVICES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    AYEN_SERVICES: '/inspector-services/',
    FEATURE_FLAGS: '/feature-flags/',
  }),
} as const;
